export default {
    FR: 'Français',
    EN: 'English',
};
